import * as fromModels from '../../../scp/preferences/models';
import * as fromPrefsSearch from '../actions/reports-prefs.actions';

export interface ReportPrefsSearchResultsState {
	preferenceSet: fromModels.PreferenceSet;
}

export const initialState: ReportPrefsSearchResultsState = {
  preferenceSet: null
};

export function reducer(state = initialState, action: fromPrefsSearch.LoadPrefsSearchResults): ReportPrefsSearchResultsState {
  switch (action.type) {
    case fromPrefsSearch.PrefsSearchResultsActionTypes.LoadPrefsSearchResults: {
      const schoolId = action.payload;

      return {
        ...updatePrefsSearchState(state, schoolId)
      };
    }
    default:
      return state;
  }
}

function updatePrefsSearchState(state: ReportPrefsSearchResultsState, schoolId: number) {
  return {
    ...state,
    schoolId
  };
}

export const getReportsPrefsSearchResults = (state: ReportPrefsSearchResultsState) => state.preferenceSet;
